export default "__VITE_ASSET__B4NlBn0h__"